var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header"),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c("CCTVStatusBox", { staticClass: "mt-5" }),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 pb-10", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0 mb-2", attrs: { align: "center" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0 pa-0",
                      class: { current_btn: _vm.currentView === "cameraList" },
                      attrs: {
                        width: "9rem",
                        height: "50px",
                        id: "header_btn",
                        elevation: "0",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.view("cameraList")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.td("cameraList")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0 pa-0",
                      class: { current_btn: _vm.currentView === "splitScreen" },
                      attrs: {
                        width: "9rem",
                        height: "50px",
                        id: "header_btn",
                        elevation: "0",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.view("splitScreen")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s("分割画面") + " ")]
                  ),
                ],
                1
              ),
              _vm.currentView == "cameraList"
                ? [_c("ThumbnailBox")]
                : [_c("SplitScreen")],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }